import React, {useState} from "react";
import Modal from "react-modal";
import Swal from "sweetalert2";
import {FaTimes} from "react-icons/fa";
import {AiOutlineFileExcel} from "react-icons/ai";
import ExcelUploader from "../../../../../helpers/ExcelUploader";
import {createMultipleContainer} from "../../../../../helpers/Api";

const ModalAgregarMultiContenedores = ({
  token,
  idSolicitud,
  modalAddContenedoresIsOpen,
  closeAddContainersModal,
}) => {
  const BASE_URL = process.env.REACT_APP_API;

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      width: "50%",
      height: "55%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      background: "linear-gradient(141.48deg, #DBFBFF -2.31%, #DBE9FF 101.54%)",
      borderRadius: "5px",
      border: "none",
      boxShadow: "0px 11px 30px 12px rgba(0, 0, 0, 0.04)",
    },
    overlay: { zIndex: 1000 },
  };

  const [file, setFile] = useState("");

  const handlerCreateDemoraAnticipada = async () => {
    try {
      const response = await createMultipleContainer(
        idSolicitud,
        { nombre_archivo: file },
        token
      );
      if (response === 200) {
        Swal.fire(
          "Exito",
          "Los contenedores se cargaron exitosamente",
          "success"
        );
        closeAddContainersModal();
      }
    } catch (error) {
      const response = error.response;
      Swal.fire("Oops", JSON.stringify(response.data), "error");
    }
  };

  const downloadEmployeeData = () => {
    fetch(`${BASE_URL}/plantilla-contenedores/`, {
                  headers: {
                    Authorization: `Token ${token}`,
                  }
                }).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "template.xlsx";
        a.click();
      });
    });
  };

  return (
    <Modal
      isOpen={modalAddContenedoresIsOpen}
      onRequestClose={closeAddContainersModal}
      style={customStyles}
      contentLabel="Example Modal"
      ariaHideApp={false}
    >
      <div className="row m-1">
        <div className="col-12  d-flex flex-row-reverse">
          <button className="btn" onClick={closeAddContainersModal}>
            <FaTimes style={{ color: "#F47777" }} />
          </button>
        </div>
      </div>
      <div className="row d-flex justify-content-center">
        <div className="col-10 mt-2">
          <>
            <div className="row d-flex justify-content-center">
              <div className="col-12">
                <h5 className="modalConfig_fontInstructions">
                  Suba mediante Excel, múltiples contenedores.
                </h5>
                <p className="modalConfig_fontInstructions mb-2">
                  Descargue
                  <button
                    className="btn"
                    onClick={() => downloadEmployeeData()}
                    style={{ color: "green" }}
                  >
                    <u>
                      esta platilla <AiOutlineFileExcel />
                    </u>
                  </button>{" "}
                  para conocer el formato requerido por la aplicación.
                </p>
              </div>

              <div className="col-10 mt-5">
                <ExcelUploader
                  setFile={setFile}
                  idSolicitud={idSolicitud}
                  token={token}
                />
              </div>
              <div className="col-8 d-flex flex-row-reverse mt-4">
                <button
                  onClick={() => handlerCreateDemoraAnticipada()}
                  className="btn btn-primary mt-4"
                >
                  Guardar
                </button>
              </div>
            </div>
          </>
        </div>
      </div>
    </Modal>
  );
};

export default ModalAgregarMultiContenedores;
